import React from 'react';
import GlowCard from './GlowCard';

const IconShell = ({ children }) => (
  <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-brand/40 bg-brand/10 text-brand">
    {children}
  </span>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.4">
    <path d="M5 13.2L9.2 17 19 7.4" />
  </svg>
);

const LibraryIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="3.5" y="4.5" width="17" height="15" rx="2.4" />
    <path d="M8 9.5H16M8 13.5H16" />
    <circle cx="8" cy="17" r="1" />
  </svg>
);

const DevicesIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="2.5" y="4.5" width="13" height="9" rx="1.8" />
    <rect x="17.5" y="7" width="4" height="10" rx="1.2" />
    <path d="M7 17.5H11M9 13.5V17.5" />
  </svg>
);

const TvIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="3" y="5" width="18" height="12" rx="2" />
    <path d="M8 19H16M12 17V19" />
  </svg>
);

const BoxIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <path d="M4 8L12 4L20 8L12 12L4 8Z" />
    <path d="M4 8V16L12 20L20 16V8" />
    <path d="M12 12V20" />
  </svg>
);

const StickIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="4" y="8" width="16" height="8" rx="4" />
    <circle cx="9" cy="12" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

const CastIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="3" y="5" width="18" height="13" rx="2" />
    <path d="M6 16.5A2.5 2.5 0 0 1 8.5 19" />
    <path d="M6 13.5A5.5 5.5 0 0 1 11.5 19" />
  </svg>
);

const DesktopIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="3" y="4.5" width="18" height="12" rx="2" />
    <path d="M9 19.5H15M12 16.5V19.5" />
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="8" y="3.5" width="8" height="17" rx="2" />
    <path d="M11 17.5H13" />
  </svg>
);

const TabletIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="6.5" y="3.5" width="11" height="17" rx="1.8" />
    <circle cx="12" cy="17.5" r="0.8" fill="currentColor" stroke="none" />
  </svg>
);

const highlights = [
  'Canales SD, HD y FHD',
  'Eventos en vivo',
  'Deportes y senales premium',
  'Canales 24/7',
  'Peliculas y series',
  'Contenido para adultos',
];

const devices = [
  { label: 'Smart TV', Icon: TvIcon },
  { label: 'TV Box', Icon: BoxIcon },
  { label: 'Fire Stick', Icon: StickIcon },
  { label: 'Chromecast', Icon: CastIcon },
  { label: 'PC', Icon: DesktopIcon },
  { label: 'Celular', Icon: PhoneIcon },
  { label: 'Tablet', Icon: TabletIcon },
];

const Features = () => {
  return (
    <section id="features" className="mx-auto grid max-w-6xl gap-8 px-4 py-14 md:px-6 lg:grid-cols-2">
      <GlowCard as="article" className="rounded-3xl border border-brand/30 bg-surface-800/90 p-6 shadow-[0_24px_40px_rgba(0,0,0,0.35)] hover:-translate-y-0.5">
        <div className="mb-4 flex items-center gap-3">
          <IconShell>
            <LibraryIcon />
          </IconShell>
          <h2 className="font-display text-2xl font-bold text-text-100">Contenido Destacado</h2>
        </div>
        <p className="mb-4 text-sm text-text-300 md:text-base">
          Canales premium y catalogo completo para ver entretenimiento sin pagar de mas.
        </p>
        <ul className="grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-2">
          {highlights.map((item) => (
            <li key={item} className="flex items-center gap-2 text-text-100">
              <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-brand/15 text-brand">
                <CheckIcon />
              </span>
              <span className="text-sm font-medium leading-tight md:text-[15px]">{item}</span>
            </li>
          ))}
        </ul>
      </GlowCard>

      <GlowCard as="article" className="rounded-3xl border border-brand/30 bg-surface-800/90 p-7 shadow-[0_24px_40px_rgba(0,0,0,0.35)] hover:-translate-y-0.5">
        <div className="mb-5 flex items-center gap-3">
          <IconShell>
            <DevicesIcon />
          </IconShell>
          <h2 className="font-display text-2xl font-bold text-text-100">Dispositivos Compatibles</h2>
        </div>
        <p className="mb-5 text-sm text-text-300 md:text-base">
          <span className="font-semibold text-brand">Sin decodificadores y sin cables.</span>{' '}
          Solo necesitas una conexion estable a internet.
        </p>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {devices.map(({ label, Icon }) => (
            <GlowCard
              key={label}
              className="rounded-2xl border border-brand/20 bg-surface-700/75 p-3 text-center transition duration-200 hover:-translate-y-0.5 hover:border-brand/45"
            >
              <span className="mx-auto mb-2 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-brand/15 text-brand">
                <Icon />
              </span>
              <p className="text-sm font-medium text-text-100">{label}</p>
            </GlowCard>
          ))}
        </div>
      </GlowCard>
    </section>
  );
};

export default Features;
